var render = function () {
  var _vm$currentRound, _vm$currentRound$doct, _vm$currentRound$doct2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'full-height',
      "customContentContainerStyles": {
        height: '100%'
      }
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm.currentRound ? _c('section', [_c('div', {
    staticClass: "whiteboard"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": (_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : (_vm$currentRound$doct = _vm$currentRound.doctorImage) === null || _vm$currentRound$doct === void 0 ? void 0 : (_vm$currentRound$doct2 = _vm$currentRound$doct.image) === null || _vm$currentRound$doct2 === void 0 ? void 0 : _vm$currentRound$doct2.src
    }
  }), _c('svg', {
    attrs: {
      "id": "whiteboardSvg",
      "width": "80%",
      "height": "90%"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.whiteboardSvg)
    }
  }), _c('svg', {
    attrs: {
      "id": "doctorBubbleSvg",
      "height": "100px",
      "width": "200px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.doctorBubbleSvg)
    }
  }), _vm.bubbleText ? _c('span', {
    class: {
      shortText: _vm.bubbleText.length < 15
    },
    attrs: {
      "id": "bubbleText"
    },
    domProps: {
      "textContent": _vm._s(_vm.bubbleText)
    }
  }) : _vm._e(), _c('div', {
    attrs: {
      "id": "sentence"
    }
  }, [!_vm.correctStep ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.currentRound.incorrectSentence)
    }
  }) : _vm._e(), _vm.correctStep ? _c('blinking-cursor-text', {
    attrs: {
      "text": _vm.correctStep.answer,
      "text-step": 0
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "choose"
  }, [_c('div', {
    attrs: {
      "id": "instructions"
    }
  }, [_c('audio-toggle-button'), _c('h1', [_vm._v("Choose the correct sentence. Then type the sentence.")])], 1), _c('form', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, _vm._l(_vm.currentRound.selectList, function (answer, index) {
    return _c('checkbox-sentence', {
      key: ("step" + index),
      attrs: {
        "handleOnKeyboardEnter": function () {
          return _vm.selectAnswer(answer);
        },
        "has-error": !answer.isCorrect,
        "index": index,
        "is-checked": answer.answer === _vm.selectedAnswerText,
        "value": answer.answer
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.selectAnswer(answer);
        }
      }
    });
  }), 1)])]) : _vm._e()])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }